import { useTranslation } from 'react-i18next'
import useSWR from 'swr'
import learningPaths from 'api/learning-paths/get'
import { LearningPathSection } from 'components/learning-path'
import Loader from 'components/ui/loader/Loader'
import { paths } from 'routes/paths'

export const LearningPaths = ({ search }: { search: string }) => {
  const { t } = useTranslation()
  const { data, isLoading } = useSWR(
    {
      key: 'learning-paths',
      search: search,
    },
    async (arg) => {
      return learningPaths({ search: arg.search })
    }
  )

  if (isLoading) return <Loader color />

  return (
    <LearningPathSection
      title={t('newhome.learningPaths.title')}
      subtitle={t('newhome.learningPaths.subtitle')}
      learningPaths={data || []}
      totalLearningPaths={data?.length || 0}
      viewMore={{
        href: paths.myCourses.learningPaths,
        text: t('newhome.learningPaths.showMore'),
      }}
    />
  )
}
